import { gql } from '@apollo/client';

export const GET_MARKET_DATES = gql`
  query GetMarketDates($seasonId: String!) {
    season(id: $seasonId) {
      markets {
        id
        name
        dates
      }
    }
    myAccount {
      currentSeason {
        id
      }
    }
  }
`;

export const GET_FEES_AND_SALES = gql`
  query GetFeesAndSales(
    $marketId: String!
    $date: String!
    $seasonId: String!
  ) {
    vendorSales(marketId: $marketId, date: $date, seasonId: $seasonId) {
      id
      vendor
      market
      date
      salesAmountInCents
      percentage
      redemptionsById {
        itemId
        amountInCents
      }
      flatFeesById {
        itemId
        amountInCents
      }
    }
    myAccount {
      settings {
        currency
      }
      currentSeason {
        id
      }
    }
    season(id: $seasonId) {
      id
      name
      vendors {
        id
        name
        categoryOptions(seasonId: $seasonId) {
          id
          name
        }
      }
      flatPlacements(marketId: $marketId, date: $date) {
        vendorId
        marketId
        date
      }
    }
    flatFees(seasonId: $seasonId) {
      id
      name
      amountInCents
    }
    pctByCategoryFees(seasonId: $seasonId) {
      id
      categoryId
      categoryName
      percentage
    }
    redemptions(seasonId: $seasonId) {
      id
      name
      invoiceTotalModifier
      addAbsValueToSalesTotal
    }
  }
`;

export const BULK_UPDATE_VENDOR_SALES = gql`
  mutation BulkUpdateVendorSales($updates: [BulkVendorSalesInput!]!) {
    bulkUpdateVendorSales(updates: $updates) {
      id
      vendor
      market
      salesAmountInCents
      redemptionsById {
        itemId
        amountInCents
      }
      flatFeesById {
        itemId
        amountInCents
      }
    }
  }
`;
